import React from "react";
import styled from "styled-components";
import Loading from "../../../components/Loadings/LoadingTable";

const SpinnerLayout = () => {
  return (
    <FallBackContainer>
      <Loading />
    </FallBackContainer>
  );
};

export default SpinnerLayout;

const FallBackContainer = styled.div`
  width: 100%;
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  `;
